var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 126,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m80.49977,124.74964",
    opacity: "NaN",
    strokeWidth: 2,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    d: "m1,1c6.54506,9.32135 50.99985,3.24999 46.99986,120.99965",
    opacity: "NaN",
    strokeWidth: 2,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000",
    id: "svg_12",
    y2: 114.49967,
    x2: 50.93735,
    y1: 121.49965,
    x1: 48.06236,
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000",
    id: "svg_14",
    y2: 114.10882,
    x2: 45.41705,
    y1: 121.73374,
    x1: 47.91703,
    strokeWidth: 2,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f21072430e5708f8e2cc5683249852af.svg";
export { ForwardRef as ReactComponent };